module.exports = __webpack_public_path__ + "img/cbd-mobile-inactive.83d9a4d.svg";